'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _displayTools = require('../../utils/display-tools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatLabel(label) {
    return label.split('_').map(function (word) {
        return word[0].toUpperCase() + word.slice(1);
    }).join(' ');
}

function KeyFigure(props) {
    var filters = props.filters;

    var data = props.data[0];
    var keys = Object.keys(data);
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: 'key-figures' },
            _react2.default.createElement(
                'div',
                { className: 'rwi-row' },
                keys.map(function (label) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'col2 key-figure', key: label },
                        _react2.default.createElement(
                            'div',
                            { className: 'kf-title' },
                            formatLabel(label)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'kf-value' },
                            (0, _displayTools.formatValue)(data[label], label)
                        )
                    );
                })
            )
        )
    );
}

exports.default = KeyFigure;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/charts/KeyFigure.js
// module id = 559
// module chunks = 0